import { createAction } from 'redux-actions';

export const GET_QUESTION_REQUEST = createAction('GET_QUESTION_REQUEST');
export const GET_QUESTION_FAILURE = createAction('GET_QUESTION_FAILURE');
export const GET_QUESTION_SUCCESS = createAction('GET_QUESTION_SUCCESS');
export const REMOVE_MARKED_QUESTION = createAction('REMOVE_MARKED_QUESTION');
